import Task from '../../helper/task';

function parseAlerts(alerts) {
    if (typeof alerts != 'object') {
        alerts = [alerts];
    }

    return alerts;
}

export default {
    settings: {
        persist: {
            storage: 'local'
        }
    },

    module: {
        namespaced: true,

        state: {
            global: [],
            connectivity: [],
            views: {
                profile: []
            }
        },
        getters: {
            view(state) {
                return view => { return view in state.views && state.views[view].length ? state.views[view].pop() : null };
            },
            connectivity(state) {
                return state.connectivity;
            }
        },
        mutations: {
            remove(state, payload) {
                const type = payload.type;
                const subType = payload.subType;
                const index = payload.index;

                if (subType && subType in state[type]) {
                    state[type][subType].splice(index, 1);
                } else {
                    state[type].splice(index, 1);
                }
            },
            removeDuplicate(state, payload) {
                state.connectivity = payload;
            },
            profile(state, alerts) {
                state.views.profile.push(parseAlerts(alerts));
            },
            views(state, alerts) {
                return view => { state.views[view].push(parseAlerts(alerts)); }
            },
            connectivity(state, alerts) {
                state.connectivity.push(parseAlerts(alerts));
            }
        },
        actions: {
            removeDuplicate({ commit }, payload) {
                commit('removeDuplicate', payload);
            },
            remove({ commit }, payload) {
                Object.entries(payload).forEach(([key, value]) => {
                    key = key.split('.');

                    let commitPayload = {
                        type: key[0],
                        index: value
                    };

                    if (key.length > 1) {
                        commitPayload.subType = key[1];
                    }

                    commit('remove', commitPayload);
                });
            },
            async addFromTask({ state, commit }, payload) {
                let task = payload;
                let to = null;

                if (task && typeof task == 'object' && !(task instanceof Task)) {
                    if ('to' in task) {
                        to = task.to;
                    }
                    if ('task' in task) {
                        task = task.task;
                    }
                }

                if (!(task instanceof Task)) {
                    throw new Error('Invalid task object for adding an alert');
                }

                const taskData = task.data();

                if (to === null && 'view' in taskData && taskData.view.toLowerCase() in state.views) {
                    to = ['views', taskData.view.toLowerCase()];
                }
                if (to === null) {
                    throw new Error('No valid alerts target defined for adding task to alerts');
                }
                if (!Array.isArray(to)) {
                    to = [to];
                }

                let alert = {
                    type: undefined,
                    message: undefined,
                    data: taskData
                }

                try {
                    alert.message = await task;
                    alert.type = 'success';
                } catch (err) {
                    alert.message = err;
                    alert.type = 'error';
                }

                const key = task.name();

                if (key) {
                    alert.key = key;
                }

                if (to.length > 1) {
                    commit(to[0], alert)(to[1]);
                } else {
                    commit(to[0], alert);
                }
            }
        }
    }
}